import React, { useContext, useState } from 'react';
import {
  Flex,
  InputSearch,
  PaginationPerPageSelect,
  Button,
  SearchContext,
  ModalContext,
  useScreenResolution,
} from 'dash-ui';
import { useTranslation } from 'react-i18next';

import PermissionCheck from 'flow-components/PermissionCheck/PermissionCheck';
import { OrganizationUsersModalsEnum } from 'pages/OrganizationPage/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/constants/constants';

function OrganizationUsersTableHeader() {
  const { t } = useTranslation('tables', {
    keyPrefix: 'organizationUsers',
  });
  const { t: tLabels } = useTranslation('common', { keyPrefix: 'labels' });
  const { setSearchSlug } = useContext(SearchContext);
  const [search, setSearch] = useState('');
  const { toggleModal } = useContext(ModalContext);
  const {
    devices: { isMobile },
  } = useScreenResolution();

  return (
    <Flex flexDirection={ isMobile ? "column" : "row" } justifyContent="center" alignItems="center" w="100%" px={6} py={4}>
      <Flex flex={1} flexDirection="row">
        <InputSearch
          w="100%"
          onClear={() => {
            setSearch('');
            setSearchSlug('');
          }}
          value={search}
          placeholder={t`searchInputPlaceholder` || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSearch(event.target.value);
            setSearchSlug(event.target.value);
          }}
        />
      </Flex>
      <Flex mt={isMobile ? 2 : 0} w={isMobile ? "100%" : "auto"}>
        <PaginationPerPageSelect label={`${tLabels`show`} `} w="100%" mx={isMobile ? 0 : 4} />
        <PermissionCheck>
          <Button
            icon="plus"
            px={5.5}
            onClick={() =>
              toggleModal(
                true,
                OrganizationUsersModalsEnum.SAVE_ORGANIZATION_USER
              )
            }
          >{t`addNewButtonLabel`}</Button>
        </PermissionCheck>
      </Flex>
    </Flex>
  );
}

export default OrganizationUsersTableHeader;
